import React, { PropsWithChildren } from 'react';
import { Flex } from '@osmosis/tailwind-ui/components/Box';

export type Props = {
  isMobileView: boolean;
} & PropsWithChildren;

/**
 * Displays different containers for topics items depending on the viewport breakpoint.
 */
const PrimaryTopicsWrapper = (props: Props) => {
  const { isMobileView, children } = props;

  return isMobileView ? (
    <>{children}</>
  ) : (
    <Flex
      className="p-2 justify-start flex-nowrap"
      data-testid="primary-topics-wrapper"
    >
      {children}
    </Flex>
  );
};

export default PrimaryTopicsWrapper;
